export default __webpack_public_path__ + "img/mtn.39805215.png";